import './App.css';

function App() {
  return (
    <div className="app-shell">
      <iframe
        className="legacy-site-frame"
        title="HUNGER"
        src="/hunger/index.html"
      />
    </div>
  );
}

export default App;
